/**
 * Regra de teto pra caches de `URL.createObjectURL`.
 *
 * Existe porque um object URL NÃO é um ponteiro barato: enquanto não é revogado, ele mantém o
 * BLOB INTEIRO vivo na memória do documento. Num terminal que fica aberto o turno todo (a doca
 * da Conferência de NF-e), milhares de blobs distintos passam pela tela e o navegador só os
 * solta no próximo reload da página — dezenas de MB retidos sem nunca serem reusados.
 */

/**
 * Chaves a revogar pra caber no teto, da menos recente pra mais recente.
 *
 * `chavesPorRecencia` é a ordem de iteração de um `Map` onde a leitura reinsere a chave — `Map`
 * itera na ordem de inserção, então a primeira chave é a menos usada (LRU sem estrutura extra).
 *
 * `emUso` protege o que ainda está montado na tela: revogar a URL de uma `<img>` viva deixa a
 * linha com a foto quebrada, sem nenhum evento que mande o React buscá-la de novo. Quando tudo
 * está em uso o teto é ultrapassado de propósito — o excedente sai na chamada seguinte, quando
 * as linhas antigas rolarem pra fora.
 */
export function selecionarObjectUrlsParaRevogar(
  chavesPorRecencia: readonly string[],
  max: number,
  emUso: (chave: string) => boolean = () => false
): string[] {
  const excedente = chavesPorRecencia.length - Math.max(0, max);
  if (excedente <= 0) return [];

  const revogar: string[] = [];
  for (const chave of chavesPorRecencia) {
    if (revogar.length >= excedente) break;
    if (emUso(chave)) continue;
    revogar.push(chave);
  }
  return revogar;
}
